import { CoverageType } from "@bluefalcon/clients-management-client-fetch";

export const coverageTypes: Record<CoverageType, string> = {
    'advantage': 'Advantage',
    'pdp': 'PDP',
    'individual': 'Individual',
    'med_supp': 'Med Supplement',
};